// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pie-chart-container[data-v-0a31380a] {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.chart-title[data-v-0a31380a] {\n  margin-bottom: 20px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #303133;\n}\n", ""]);
// Exports
module.exports = exports;
